module.exports = __webpack_public_path__ + "dd79188a1a424a4ec1cb52dff00e7f50.pdf";